import React from 'react';
import { Path, Rect, Circle, Line, Polygon, Polyline, Svg } from 'react-native-svg';
import type { IconProps } from './types';

export const CallIcon: React.FC<IconProps> = ({
  size = 16,
  color = '#020202',
  style,
  ...props
}) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 16 17"
    fill="none"
    overflow="visible"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
    style={[{ overflow: 'visible' } as const, style] as unknown}
  >
    <Path
      d="M11.6269 11.2214L13.3287 13.0911C13.6891 13.487 13.6314 14.1069 13.2041 14.4294C11.8286 15.4679 9.91092 15.4007 8.70155 14.1727C7.58303 13.037 6.26458 11.5775 5.369 10.1985C4.41529 8.72994 3.54615 6.74437 2.9296 5.17065C2.33112 3.64306 2.87676 1.93382 4.18614 0.945277C4.68239 0.570626 5.39823 0.756081 5.65014 1.32456L6.61517 3.50231C6.75593 3.81998 6.72172 4.18794 6.52479 4.47421L5.85113 5.45347C5.70986 5.65883 5.65009 5.90909 5.70741 6.15167C5.83934 6.70998 6.17484 7.81677 6.9476 9.00669C7.72986 10.2112 8.49886 10.7906 8.88158 11.0264C9.04059 11.1243 9.22957 11.1469 9.41399 11.1174L10.7295 10.9071C11.0625 10.8538 11.3999 10.972 11.6269 11.2214Z"
      stroke="black"
      strokeWidth="1.5"
    />
  </Svg>
);

CallIcon.displayName = 'CallIcon';
